// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__gZFEN","footer":"ModalInfo_footer__gvBhi"};